import { IntegrationPageTemplate } from '@/components/IntegrationPageTemplate'
import { getIntegration } from '@/data/integrations'

export default function EmailDeliveryIntegrationPage() {
  return <IntegrationPageTemplate integration={getIntegration('email-delivery')} />
}
